module.exports = __webpack_public_path__ + "static/media/commercial-2.0cc0aff4.svg";